<template>
  <div
    id="app"
    class="login-page"
    :class="!isAdmin || 'is-admin'"
  >
    <app-header
      :class="{ 'long-title-menu-down': ((isLoggedIn && isAdmin) || !isLoggedIn)}"
      app-title="Lead Certification Submission System"
      app-subtitle="Lead and Healthy Homes Program"
    >
      <template
        v-if="$route.name !== 'maintenance'"
        v-slot:mobile-menu
      >
        <mobile-menu>
          <nav-bar-menu />
        </mobile-menu>
      </template>
      <nav-bar-menu v-if="$route.name !== 'maintenance'" />
    </app-header>
    <main class="container main">
      <router-view />
    </main>
    <app-footer
      class="p-t-sm p-b-sm"
      :links="footerLinks"
    />

    <!-- Modals -->
    <custom-dialog />
    <!-- <contact-us /> -->

    <!-- <v-dialog class="content" /> -->
  </div>
</template>
<script>
import NavBarMenu from '@/components/NavBarMenu';
import CustomDialog from '@/components/modals/CustomDialog';
// import ContactUs from '@/components/ContactUs';

export default {
  name: "FullHeightLayout",
  components: {
    NavBarMenu,
    CustomDialog,
    // ContactUs,
  },
  data() {
    return {
      footerLinks: [
        {
          text: 'Terms of use',
          href: this.showTermsAndConditions,
          attrs: {
            href: "#",
            tabindex: "0",
          },
        },
        {
          text: 'Contact us',
          href: '/contact-us',
          attrs: {
            tabindex: "0",
            target: "_blank",
          },
        },
        {
          text: 'FAQ',
          href: '/faq',
          attrs: {
            tabindex: "0",
            target: "_blank",
          },
        },
      ],
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.auth.isAuthenticated;
    },
  },
};
</script>
<style lang="scss">
#app {
  .navbar {
    .maintenance-icon {
      font-size: 2rem;
      color: #ffefa2;
    }
  }
  position: relative;
  &.login-page {
    &:after {
      content: "";
      background-image: url(./../assets/images/login-background.png);
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      background-attachment: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      position: fixed;
      z-index: -1;
    }
    // height: 100vh;
    background: rgba(255, 255, 255, 0.8);
  }
}
</style>
